import { Loader, TextInput, TextInputProps } from '@mantine/core';
import { FC, FocusEventHandler, useRef, useState } from 'react';

interface Props extends TextInputProps {
  onBlurSave: (val: string) => Promise<boolean>;
  validate?: (val: string) => boolean;
  errorMessage?: string;
}

const BookitupTextInput: FC<Props> = ({ onBlurSave, validate, errorMessage, onBlur, onFocus, ...rest }) => {
  const [updating, setUpdating] = useState(false);
  const ref = useRef<HTMLInputElement>(null);
  const valueOnFocus = useRef<string>();

  // eslint-disable-next-line no-underscore-dangle
  const _onBlur = async (val: string) => {
    setUpdating(true);
    await onBlurSave(val);
    setUpdating(false);
  };

  const getErrorNode = () => {
    const { value } = ref.current ?? { value: null };
    if (!value || !validate) return null;
    if (validate(value)) return null;
    return errorMessage ?? 'Upps etwas ist schief gelaufen';
  };

  const handleFocus: FocusEventHandler<HTMLInputElement> = (event) => {
    valueOnFocus.current = event.currentTarget.value;
    onFocus?.(event);
  };

  const handleBlur: FocusEventHandler<HTMLInputElement> = (event) => {
    const { value } = event.currentTarget;
    onBlur?.(event);

    if (value === valueOnFocus.current) return;

    valueOnFocus.current = value;
    _onBlur(value);
  };

  return (
    <TextInput
      ref={ref}
      rightSection={updating && <Loader size="xs" />}
      onFocus={handleFocus}
      onBlur={handleBlur}
      error={getErrorNode()}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...rest}
    />
  );
};

export default BookitupTextInput;
